import type { HotelReservationPageProps } from "@b2bportal/core-hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { LodgingCfarContractStatus } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { TripsAppPage } from "@tenant/ui";
import clsx from "clsx";
import { TripDetailContent } from "./components";
import styles from "./styles.module.scss";
import { useHotelReservationPage } from "./useHotelReservationPage";
import { PageLoadingScreen } from "@/overrides/core-ui/PageLoadingScreen/PageLoadingScreen";
import { findCfarContract } from "@/utilities/hotels/cfar";

const COMPONENT_KEY = CoreHotelsComponent.HotelReservationPage;

export const HotelReservationPage = ({
  context,
  className,
  children,
}: HotelReservationPageProps) => {
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const { reservation, itinerary, isLoading, onQueryCancellation } =
    useHotelReservationPage(context);

  const cfarContract = findCfarContract(itinerary?.ancillaries);
  const isCfarExercised =
    itinerary?.cfar?.status === LodgingCfarContractStatus.Exercised;

  const isActiveBooking =
    reservation != null &&
    !isCfarExercised &&
    reservation.state.ReservationState !== "Cancelled" &&
    reservation.state.ReservationState !== "Pending";

  return (
    <TripsAppPage
      className={clsx(block, className)}
      contentClassName={cn("content")}
    >
      {isLoading ? (
        <PageLoadingScreen className="" isLoading text={t("fetchingTrips")} />
      ) : (
        <TripDetailContent
          reservation={reservation}
          itinerary={itinerary}
          isActiveBooking={isActiveBooking}
          onQueryCancellation={onQueryCancellation}
          cfarContract={cfarContract}
          isCfarExercised={isCfarExercised}
        >
          {children}
        </TripDetailContent>
      )}
    </TripsAppPage>
  );
};
